module.exports = __webpack_public_path__ + "img/Unidad18-5.97cdada5.png";